import { useEffect } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { ProfileType } from '@/enum/profile-type'
import { trackPageView } from '@/utils/analytics'

import { BigFooter } from './components/footer/big-footer'
import { Footer } from './components/footer/footer'
import { Navbar } from './components/navbar'
import { useAuth } from './contexts'

function Layout() {
  const { pathname } = useLocation()
  const { signed, userProfiles } = useAuth()

  useEffect(() => {
    window.scrollTo(0, 0)
    trackPageView(pathname)
  }, [pathname])

  const bigFooterPaths = [
    '/login',
    '/register',
    '/contact',
    '/property',
    '/reset-password',
    '/reset-password/email',
    '/backoffice',
    '/confirm-email',
    '/not-allowed',
  ]

  function showFooter() {
    return (
      bigFooterPaths.find((path) => {
        if (pathname === '/') return undefined

        return pathname.startsWith(path)
      }) === undefined
    )
  }

  const pathsInaccessibleWhenIsLogged = [
    '/login',
    '/register/preserver',
    '/register/sponsor',
  ]

  function redirectWhenIsLogged() {
    return pathsInaccessibleWhenIsLogged.some((path) =>
      pathname.startsWith(path),
    )
  }

  const isAdminOrSuperAdmin =
    userProfiles?.includes(ProfileType.Admin) ||
    userProfiles?.includes(ProfileType.SuperAdmin)

  if (signed && isAdminOrSuperAdmin && redirectWhenIsLogged()) {
    return <Navigate to="/backoffice/properties" />
  }

  const isNotAdmin = !userProfiles?.includes(ProfileType.Admin)
  const isNotSuperAdmin = !userProfiles?.includes(ProfileType.SuperAdmin)
  const isNotAdminOrSuperAdmin = isNotAdmin && isNotSuperAdmin

  if (signed && isNotAdminOrSuperAdmin && redirectWhenIsLogged()) {
    return <Navigate to="/dashboard" />
  }

  function isVisibleFooter() {
    const isSimulation = pathname.endsWith('/simulation')

    const isBackOffice = pathname.startsWith('/backoffice')

    return isSimulation || !isBackOffice
  }

  return (
    <div className="flex min-h-screen w-screen flex-col">
      {!pathname.endsWith('/simulation') && <Navbar />}
      <Outlet />
      {!signed && showFooter() && <BigFooter />}
      {pathname !== '/register' && isVisibleFooter() && <Footer />}
    </div>
  )
}

export default Layout
